'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'

export function PostHogProvider({
    children,
}: {
    children: React.ReactNode
}) {
    useEffect(() => {
        const key = process.env.NEXT_PUBLIC_POSTHOG_KEY
        // No key configured (local sandboxes) — skip init entirely.
        if (!key) return
        // Outside production, opt out of all capturing instead of tracking.
        if (process.env.NODE_ENV !== "production") {
            posthog.opt_out_capturing()
            return
        }
        posthog.init(key, {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
            person_profiles: 'identified_only',
        })
    }, [])

    return children
}
